import { Divider } from 'antd'
import React from 'react'

import PackageInfoCard from '../../components/package/PackageInfoCard'
import PackageOtherLangInfo from '../../components/package/PackageOtherLangInfo'
import StickerInfoList from '../../components/sticker/StickerInfoList'
import { PackageInfo } from '../../types'

export default function PackageAndStickerInfo({
  packageInfo,
}: {
  packageInfo: PackageInfo
}) {
  return (
    <div style={{ width: 740 }}>
      <PackageInfoCard packageInfo={packageInfo} />
      <br />
      <PackageOtherLangInfo packageInfo={packageInfo} />
      <Divider />
      <div style={{ marginTop: 31 }}>
        <StickerInfoList
          stickerList={packageInfo.emoticons ? packageInfo.emoticons : []}
        />
      </div>
    </div>
  )
}
